export default {
  path: '/resource',
  component: () => import('../components/Index'),
  children: [
    {
      path: "/",
      redirect: "papers",
    },
    {
      path: "papers",
      component: () => import('../components/resource/Papers'),
    },
    {
      path: "advanced",
      component: () => import('../components/resource/Advanced'),
    },
    {
      path: "quote",
      component: () => import('../components/resource/Quote'),
    },
    {
      path: "papers-composing",
      component: () => import('../components/resource/PapersComposing'),
    },
    {
      path: "papers-edit",
      component: () => import('../components/resource/PapersEdit'),
    },
  ]
}


// WEBPACK FOOTER //
// ./src/pages/pc/router/resource.js